module.exports = __webpack_public_path__ + "static/media/atlanta_logo.eb63d14a.png";